require('./bootstrap');
require('parsleyjs');
window.libphonenumber = require('libphonenumber-js');

